import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import ResponsivePhotoSlider from '../components/slider/Slider';

import './../styles/project.css';



const Project=()=>{
    
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { name } = useParams(); 
    
    useEffect(() => {
      fetch('https://inkochetkov.github.io/data/projects.json') 
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          setData(data);
          setLoading(false);
        })
        .catch(error => {
          setError(error);
          setLoading(false);
        });
    }, []);
    
    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;
  
    const project = data.find(obj => {
      return obj.name === name;
    });
  
    if (!project) return <div>Project not found</div>; // Additional check
  

    return (
        <>
            <Helmet>
                <title>{project.name}</title>
                <meta name="description" content={project.description_ru}  />
            </Helmet>
            <div className="app">
                <div className="main">
                <a href={`/projects/`}    data-title ="Назад" style={{color:'white' , marginLeft:'10%'}}>Назад</a> 
                <div className="project">
                        <p className="project-text">
                        <br/>
                        <br/>
                        Название проекта: {project.name}
                        <br/>
                        Тип: {project.title_ru}
                        <br/>
                        Используемые технологии: {project.stack} 
                        <br/>         
                        Описание: {project.description_ru}    
                        <br/>          
                        Год реализации: {project.year}
                        </p>
                        <br/>
                        <br/>
                        </div>
                        {project.link && (
                            <a href={project.link}    data-title ="Ссылка на ресурс" style={{color:'white' , marginLeft:'10%'}}>                             
                                 Ссылка на ресурс                
                            </a> 
                            )
                        }
                        {project.images.length > 0 &&(         
                        <div className="app-container">
                            <ResponsivePhotoSlider images={project.images} />
                        </div>
                            )
                        }
                </div>
            </div>
        </>  
    );
}
export default Project;